import Laravel from '@/services/Laravel'

const EmailService = {
  sendFeedback: (data) => {
    return Laravel.post('/send/feedback-form', data)
  },
}

export default EmailService
